/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
import WarningSelfXSSService from './services/WarningSelfXSS';

function init() {
  WarningSelfXSSService.warn(window.console.log);
}

export default init;
